<template>
  <div class="topic_progress">
    <div class="expRevSchedule">
      <div class="progress pro-expertReview">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" :style="scheduleList[processActive].style"></div>
        <div class="proPoint" :class="{active: pointActive >= index,['proPoint' + (index + 1)]: true}" v-for="(item, index) in scheduleList" :key="index" @click="handleScheduleChange(index)">
          <a>
            <i :class="{ no: pointActive == index && noPassActive == index }">{{ index + 1 }}</i>
            {{ item.name }}
          </a>
        </div>
      </div>
    </div>
    <div class="opinion_list">
      <div class="opinion_item" @click="viewOpinion(index1)" :class="{ hidden: isShowOpinion(index1) }" v-for="(item1, index1) in 10" :key="index1">意见</div>
    </div>
    <div class="report_list">
      <div class="report_item" :class="{ hidden: isShowReport(index2) }" v-for="(item2, index2) in 10" :key="index2" @click="uploadReport(index2)">{{getReportBtnText(index2)}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String | Number,
      default: 0
    }
  },
  watch: {
    status(val) {
      this.initProcess()
    }
  },
  data() {
    return {
      pointActive: 0, //点索引
      processActive: 0, //进程索引
      noPassActive: null, //不通过的点
      scheduleList: [
        // { name: '开题', style: 'width:0%;' },
        // { name: '校审核', style: 'width:8.33%;' },
        // { name: '区审核', style: 'width:16.66%;' },
        // { name: '中期', style: 'width:24.99%;' },
        // { name: '校审核', style: 'width:33.33%;' },
        // { name: '区审核', style: 'width:41.66%;' },
        // { name: '结题申请', style: 'width:49.99%;' },
        // { name: '校审核', style: 'width:58.33%;' },
        // { name: '区审核', style: 'width:66.66%;' },
        // { name: '结题', style: 'width:74.99%;' },
        // { name: '校审核', style: 'width:83.33%;' },
        // { name: '区审核', style: 'width:91.66%;' },
        // { name: '已结题', style: 'width:100%;' }
        { name: '开题', style: 'width:0%;' },
        { name: '校审核', style: 'width:11.11%;' },
        { name: '区审核', style: 'width:22.22%;' },
        { name: '中期', style: 'width:33.33%;' },
        { name: '校审核', style: 'width:44.44%;' },
        { name: '区审核', style: 'width:55.55%;' },
        { name: '结题', style: 'width:66.66%;' },
        { name: '校审核', style: 'width:77.77%;' },
        { name: '区审核', style: 'width:88.88%;' },
        { name: '已结题', style: 'width:100%;' }
      ]
    };
  },
  computed: {
    // 控制意见按钮的显示和隐藏
    isShowOpinion(index) {
      return index => {
        if ([0, 3, 6, 9, 12].includes(index)) {
          return true;
        } else {
          if (this.pointActive < index) {
            return true;
          }
        }
      };
    },
    // 控制报告的显示和隐藏
    isShowReport(index) {
      return index => {
        if (![0, 3, 6, 9].includes(index)) {
          return true;
        } else {
          if (this.pointActive < index) {
          return true;
        }
        }
      };
    },
    getReportBtnText(index) {
      return index => {
        switch (this.status) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            if (index === 0) {
              return '上传报告'
            }
            break;
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
            if (index === 3) {
              return '上传报告'
            } else if (index < 3) {
              return '查看报告'
            }
            break;
          //   case 10:
          //   case 11:
          //   case 12:
          //   case 13:
          //   case 14:
          //     if (index === 6) {
          //       return '上传报告'
          //     } else if (index < 6) {
          //       return '查看报告'
          //     }
          //     break;
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
            if (index === 6) {
              return '上传报告'
            } else if (index < 6) {
              return '查看报告'
            }
            break;
          case 20:
          case 21:
          case 22:
          case 23:
          case 24:
          case 25:
          case 26:
          case 27:
          case 28:
          case 29:
          case 30:
          case 31:
          case 32:
          case 33:
          case 34:
            return '查看报告'
          case 35:
          default:
            break;
        }
      }
    },
  },
  created() {
    this.initProcess()
  },
  methods: {
    // 上传报告
    uploadReport(index) {
      this.$emit('uploadReport', index);
    },
    // 查看意见
    viewOpinion(index) {
      this.$emit('viewOpinion', index);
    },
    initProcess() {
      switch (this.status) {
        case 0:
          this.pointActive = 0
          this.processActive = 0
          break;
        case 1:
          this.pointActive = 0
          this.processActive = 1
          break;
        case 2:
          this.pointActive = 1
          this.processActive = 1
          this.noPassActive = 1
          break;
        case 3:
          this.pointActive = 1
          this.processActive = 2
          break;
        case 4:
          this.pointActive = 2
          this.processActive = 2
          this.noPassActive = 2
          break;
        case 5:
          this.pointActive = 3
          this.processActive = 3
          break;
        case 6:
          this.pointActive = 3
          this.processActive = 4
          break;
        case 7:
          this.pointActive = 4
          this.processActive = 4
          this.noPassActive = 4
          break;
        case 8:
          this.pointActive = 4
          this.processActive = 5
          break;
        case 9:
          this.pointActive = 5
          this.processActive = 5
          this.noPassActive = 5
          break;
        // case 10:
        //   this.pointActive = 6
        //   this.processActive = 6
        //   break;
        // case 11:
        //   this.pointActive = 6
        //   this.processActive = 7
        //   break;
        // case 12:
        //   this.pointActive = 7
        //   this.processActive = 7
        //   this.noPassActive = 7
        //   break;
        // case 13:
        //   this.pointActive = 7
        //   this.processActive = 8
        //   break;
        // case 14:
        //   this.pointActive = 8
        //   this.processActive = 8
        //   this.noPassActive = 8
        //   break;
        case 15:
          this.pointActive = 6
          this.processActive = 6
          break;
        case 16:
          this.pointActive = 6
          this.processActive = 7
          break;
        case 17:
          this.pointActive = 7
          this.processActive = 7
          this.noPassActive = 7
          break;
        case 18:
          this.pointActive = 7
          this.processActive = 8
          break;
        case 19:
          this.pointActive =8
          this.processActive = 8
          this.noPassActive = 8
          break;
        case 20:
        case 21:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 27:
        case 28:
        case 29:
        case 30:
        case 31:
        case 32:
          this.pointActive = 8
          this.processActive = 9
          break;
        case 33:
          this.pointActive = 9
          this.processActive = 9
          this.noPassActive = 9
          break;
        case 34:
          this.pointActive = 9
          this.processActive = 9
          return '已结题'
          break;
        case 35:
          this.pointActive = 9
          this.processActive = 9
          this.noPassActive = 9
          return '拟结题退回修改'
          break;
        default:
          return '未知错误'
      }
    },
    handleScheduleChange() { },
  }
};
</script>

<style lang="scss" scoped>
// 隐藏不需要显示的意见
.opinion_item.hidden {
  visibility: hidden;
}

.proPoint.active .no {
  background-color: red;
}

.topic_progress {
  position: relative;
}
.opinion_list,
.report_list {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  color: #6ac8f1;
  cursor: pointer;
}
.opinion_list {
  top: 5px;
  left: 0;
  .opinion_item {
    width: 10%;
    text-align: center;
  }
}
.report_list {
  bottom: 15px;
  left: 0;
  .report_item {
    background-color: #409eff;
    width: 10%;
    color: #fff;
    text-align: center;
    padding: 2px;
    border-radius: 5px;
  }
  .report_item.hidden {
    visibility: hidden;
  }
}
.pro-expertReview .proPoint1 {
  left: 0;
}
.pro-expertReview .proPoint2 {
  left: 11.11%;
}
.pro-expertReview .proPoint3 {
  left: 22.22%;
}
.pro-expertReview .proPoint4 {
  left: 33.33%;
}
.pro-expertReview .proPoint5 {
  left: 44.44%;
}
.pro-expertReview .proPoint6 {
  left: 55.55%;
}
.pro-expertReview .proPoint7 {
  left: 66.66%;
}
.pro-expertReview .proPoint8 {
  left: 77.77%;
}
.pro-expertReview .proPoint9 {
  left: 88.88%;
}
.pro-expertReview .proPoint10 {
  left: 100%;
}
// .pro-expertReview .proPoint1 {
//   left: 0;
// }
// .pro-expertReview .proPoint2 {
//   left: 8.33%;
// }
// .pro-expertReview .proPoint3 {
//   left: 16.66%;
// }
// .pro-expertReview .proPoint4 {
//   left: 24.99%;
// }
// .pro-expertReview .proPoint5 {
//   left: 33.33%;
// }
// .pro-expertReview .proPoint6 {
//   left: 41.66%;
// }
// .pro-expertReview .proPoint7 {
//   left: 49.99%;
// }
// .pro-expertReview .proPoint8 {
//   left: 58.33%;
// }
// .pro-expertReview .proPoint9 {
//   left: 66.66%;
// }
// .pro-expertReview .proPoint10 {
//   left: 74.99%;
// }
// .pro-expertReview .proPoint11 {
//   left: 83.33%;
// }
// .pro-expertReview .proPoint12 {
//   left: 91.66%;
// }
// .pro-expertReview .proPoint13 {
//   left: 99.99%;
// }
</style>
